let dict = {
  Gascon: 'Gascón',
};

export default function lastNameDict(name) {
  return dict[name] ? dict[name] : name;
}
